<!-- @format -->

<info-basic-information-tag>

    <div class="container_contents">

        <div class="container_breadcrumb">
            <ul class="breadcrumb">
                <li class="breadcrumb-item"><a href="/info" class="information">会員情報</a></li>
                <li class="breadcrumb-item"><h1>登録基本情報の更新申請｜申請内容の確認</h1></li>
            </ul>
        </div>

        <div class="contents">
            <section class="contents_area">

                <div class="contents_block">
                    <h1 style="font-size: 2.5rem;text-align: center;margin-bottom:1rem">
                        登録基本情報の更新申請｜申請内容の確認
                    </h1>

                    <div is="confirm"></div>
                </div>

            </section>
        </div>

    </div>
    <script>
        import confirm from "@tags/parts/info/basic-information/application-confirm.riot";

        export default {
            components: {
                "confirm": confirm
            }
        }
    </script>
</info-basic-information-tag>